import gql from 'graphql-tag'

export default gql`mutation updateProjectInvoiceAmount($project_id: String!, $amount: Float!) {
    updateProjectInvoiceAmount(project_id: $project_id, amount: $amount) @client
}`